import { render } from "./SearchResultCustomer.vue?vue&type=template&id=5506442a&scoped=true"
import script from "./SearchResultCustomer.vue?vue&type=script&lang=js"
export * from "./SearchResultCustomer.vue?vue&type=script&lang=js"

import "./SearchResultCustomer.vue?vue&type=style&index=0&id=5506442a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5506442a"]])

export default __exports__